// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MemberAlertDestinationsQueryVariables = Types.Exact<{
  membershipId: Types.Scalars["ID"]["input"];
}>;

export type MemberAlertDestinationsQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationMembershipDetails: {
    __typename?: "OrganizationMembership";
    id: string;
    userIsSelf: boolean;
    alertDestinations: Array<{
      __typename?: "AlertDestination";
      id: string;
      name: string;
    }>;
  };
};

export const MemberAlertDestinationsDocument = gql`
  query MemberAlertDestinations($membershipId: ID!) {
    getOrganizationMembershipDetails(membershipId: $membershipId) {
      id
      userIsSelf
      alertDestinations {
        id
        name
      }
    }
  }
`;

/**
 * __useMemberAlertDestinationsQuery__
 *
 * To run a query within a React component, call `useMemberAlertDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberAlertDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberAlertDestinationsQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useMemberAlertDestinationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberAlertDestinationsQuery,
    MemberAlertDestinationsQueryVariables
  > &
    (
      | { variables: MemberAlertDestinationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MemberAlertDestinationsQuery,
    MemberAlertDestinationsQueryVariables
  >(MemberAlertDestinationsDocument, options);
}
export function useMemberAlertDestinationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberAlertDestinationsQuery,
    MemberAlertDestinationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberAlertDestinationsQuery,
    MemberAlertDestinationsQueryVariables
  >(MemberAlertDestinationsDocument, options);
}
// @ts-ignore
export function useMemberAlertDestinationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MemberAlertDestinationsQuery,
    MemberAlertDestinationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MemberAlertDestinationsQuery,
  MemberAlertDestinationsQueryVariables
>;
export function useMemberAlertDestinationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberAlertDestinationsQuery,
        MemberAlertDestinationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MemberAlertDestinationsQuery | undefined,
  MemberAlertDestinationsQueryVariables
>;
export function useMemberAlertDestinationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberAlertDestinationsQuery,
        MemberAlertDestinationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberAlertDestinationsQuery,
    MemberAlertDestinationsQueryVariables
  >(MemberAlertDestinationsDocument, options);
}
export type MemberAlertDestinationsQueryHookResult = ReturnType<
  typeof useMemberAlertDestinationsQuery
>;
export type MemberAlertDestinationsLazyQueryHookResult = ReturnType<
  typeof useMemberAlertDestinationsLazyQuery
>;
export type MemberAlertDestinationsSuspenseQueryHookResult = ReturnType<
  typeof useMemberAlertDestinationsSuspenseQuery
>;
export type MemberAlertDestinationsQueryResult = Apollo.QueryResult<
  MemberAlertDestinationsQuery,
  MemberAlertDestinationsQueryVariables
>;
